// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/Accordion/AccordionPanel.less
// module id = 818
// module chunks = 0